import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loadingscreen',
  templateUrl: './loadingscreen.component.html',
  styleUrls: ['./loadingscreen.component.scss']
})
export class LoadingscreenComponent implements OnInit {
  @Input() myInput: any;

  brandChars = 'ALUGULOO'.split('');

  particles = Array.from({ length: 18 }, () => ({
    x:        Math.random() * 100,
    y:        Math.random() * 100,
    size:     Math.random() * 6 + 3,
    delay:    Math.random() * 5,
    duration: Math.random() * 4 + 4,
  }));

  ngOnInit(): void {}
}
